import { Injector } from "@angular/core";
import { SimpleSearchListNode } from "../../SimpleSearchListNode"
import { EntityEnum } from "../../EntityEnum";
import { PharmaceuticalFormsEntityListView } from "../../../Data/MedicinalProductData/PharmaceuticalFormsEntityListView";
import { PharmaceuticalFormAutoUploadEntity } from "../Entity/PharmaceuticalFormAutoUploadEntity";
import { LookupGetService } from "../../../../service/lookup-service/lookup-get.service";
import { BaseNode } from "../../BaseNode";


export class TreeNodeMedicinalProductsPharmaceuticalForm extends SimpleSearchListNode {
    useHist: boolean = false;
    constructor(injector: Injector, items: any[]|undefined, useHist: boolean) {
        super(injector, new PharmaceuticalFormsEntityListView(items), 'Pharmaceutical Forms', useHist ? EntityEnum.pharmaceuticalFormHist : EntityEnum.pharmaceuticalForm);
        this.useHist = useHist;
    }

    override addChild(model: any): BaseNode|undefined {
        const labelTemplate = `${this.ioc!.get(LookupGetService).retrieveValueFromCache('type_Term', model.type_Term)} - ${model.ev_Code} - ${model.name_Pharmform}`;
        return this.addChildNode(PharmaceuticalFormAutoUploadEntity,labelTemplate, this,model,this.useHist,false,false);
        // add specific nodes for this entity

    }
    override getCriteriaFields(): string[] {
        return ['type_Term', 'ev_Code', 'name_Pharmform'];
    }

    override getPlaceHolderTemplate(): string {
        return "Search for pharmaceutical forms available in the XEVMPD [visibility restrictions may apply] including those owned by your HQ";
    }
}